import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Nav from "react-bootstrap/Nav";
import { Navbar, Dropdown } from "react-bootstrap";

const HeaderLoggedInDesktop = ({auth}) => {
    //console.log(auth);

    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown on outside click
    useEffect(() => {
        const handleClickOutside = (event) => {
        if (
            dropdownRef.current &&
            !dropdownRef.current.contains(event.target)
        ) {
            setShowDropdown(false);
        }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
        document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    // Add null checks to prevent errors when auth data is still loading
    const userInitial = auth?.first_name ? auth.first_name.charAt(0).toUpperCase() : null;

    const navbarStyle = {
        height: "56px", 
        background: 'rgba(255, 255, 255, 0.98)',
        boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        backdropFilter: 'blur(10px)',
        paddingRight: "5px"
    };

    // Don't render if auth data isn't loaded yet
    if (!auth || !auth.id) {
        return (
            <div className="d-lg-block d-none">
                <Navbar fixed="top" collapseOnSelect expand="lg" className="navbar-custom" style={navbarStyle}>
                    <Navbar.Brand>
                        <a href="/" style={{color: "#2d3748",textDecoration:"none", marginLeft:"10px", fontWeight:"500"}}>
                            Elliot Koss
                        </a>
                    </Navbar.Brand>
                </Navbar>
            </div>
        );
    }

    return (
        <>
        <div className="d-lg-block d-none">            
                <Navbar fixed="top" collapseOnSelect expand="lg" className="navbar-custom" style={navbarStyle}>
                    
                        <Navbar.Brand>
                            <a href="/" style={{color: "#2d3748",textDecoration:"none", marginLeft:"10px", fontWeight:"500"}}>
                                Elliot Koss
                            </a>
                        </Navbar.Brand>

                        <Nav className="ms-auto">
                            <a href="/dashboard" 
                                className="d-inline-flex align-items-center p-2"
                                style={{
                                    color: "#4a5568", 
                                    textDecoration: "none",
                                    fontSize: "1.1rem", 
                                    fontWeight: "400", 
                                    lineHeight: "1.5", 
                                    borderRadius: "0.25rem",
                                }}
                            >
                                <i  className="bi bi-speedometer2" 
                                    style={{
                                        marginRight: "0.3rem",
                                        lineHeight: ".8",       
                                        verticalAlign: "middle",
                                        color:"#4a5568" 
                                }}
                                ></i> Dashboard
                            </a>
                            
                            <a href="/ai-notes" 
                                className="d-inline-flex align-items-center p-2"
                                style={{
                                    color: "#4a5568", 
                                    textDecoration: "none",
                                    fontSize: "1.1rem", 
                                    fontWeight: "400", 
                                    lineHeight: "1.5", 
                                    borderRadius: "0.25rem",
                                }}
                            >
                                AI Notes
                            </a>

                            {auth && auth.role === 'admin' && (
                                <a href="/admin/ai-notes"
                                    className="d-inline-flex align-items-center p-2"
                                    style={{
                                        color: "#4a5568", 
                                        textDecoration: "none",
                                        fontSize: "1.1rem", 
                                        fontWeight: "400", 
                                        lineHeight: "1.5", 
                                        borderRadius: "0.25rem",
                                    }}
                                >
                                    Post Notes
                                </a>
                            )}

                            {/*
                            <Link to="/logout" style={{
                                color: "#000000", 
                                textDecoration: "none", 
                                padding: "0.375rem 0.75rem",
                                display: "inline-block", 
                                fontSize: "1rem", 
                                fontWeight: "400", 
                                lineHeight: "1.5", 
                                borderRadius: "0.25rem",
                                verticalAlign: "baseline"
                                }}
                            >
                                <button className="btn btn-success" style={{backgroundColor:"#067100"}}>
                                    Logout
                                </button>
                            </Link>   
                            */}

                            <div className="d-flex align-items-center p-2" ref={dropdownRef}>
                                <Dropdown show={showDropdown} onToggle={() => {}}>
                                    <div
                                    as="div"
                                    onClick={() => setShowDropdown(!showDropdown)}
                                    style={{
                                        width: '30px',
                                        height: '30px',
                                        borderRadius: '50%',
                                        backgroundColor: '#067100',
                                        color: 'white',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: 'pointer',
                                        userSelect: 'none',
                                        fontSize:"0.9em",
                                    }}
                                    >
                                        {userInitial === null ? <i class="bi bi-person-fill"></i> : userInitial}
                                    </div>

                                    <Dropdown.Menu align="end" show={showDropdown}  className="custom-dropdown-menu p-0">
                                        <Dropdown.Item 
                                            href="/logout" 
                                            className="py-2" 
                                            style={{ color:"#dc3545", fontSize:"0.9rem"}}
                                        >
                                            Logout
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown> 
                            </div>
                        
                        </Nav>
                    
                </Navbar>
        </div>
        </>
    )
}

function mapStateToProps({auth}) {
    return { auth };
}

export default connect(mapStateToProps)(HeaderLoggedInDesktop);